import {useSelector} from 'react-redux';
import {scopesSelector} from '../store/Slices/userSlice';

// Scope strings are authored inline all over the app (e.g. 'is-admin,foo:list').
// Trim each entry so an accidental space after a comma does not silently turn a
// granted permission into one that can never match.
const parseScopes = (scope: string) =>
  scope
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

export const useUserCan = (scope = '') => {
  const scopes = useSelector(scopesSelector);
  const scopesToCheck = parseScopes(scope);
  const havePermission = scopesToCheck.every(s => scopes.includes(s));
  return havePermission;
};

export const useUserCanAny = (scope = '') => {
  const scopes = useSelector(scopesSelector);
  const scopesToCheck = parseScopes(scope);
  const havePermission = scopesToCheck.some(s => scopes.includes(s));
  return havePermission;
};
